import { apiFetch } from './client';

export const versionApi = {
  get: () => apiFetch<{ version: string }>('/version')
};
